import React from "react";
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import DatePicker from "~/common/components/DatePicker";
import MultiCheckboxSelect from "~/common/components/MultiCheckboxSelect";
import Select from "~/common/components/Select";
import Textarea from "~/common/components/textarea";
import Tag from "~/common/components/Tag";
import FileUploader from "~/common/components/FileUploader";
import Address from "~/common/components/Address";
import Radio from "~/common/components/Radio";
import ViewTitle from "./viewTitle";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";

const ViewInquery = ({ applyForm, applyQuestList }) => {
	const { t } = useTranslation();
	let catNum = 0;
	let subNum = 0;
	const addCatNum = () => {
		catNum++;
		subNum = 0;
	};
	const country = applyForm.watch("company.country") || "";

	return (
		<div className="apply-form-wrap">
			<Form useForm={applyForm} className="apply-form light">
				{applyQuestList &&
					applyQuestList.length > 0 &&
					applyQuestList.map((inquiry, index) => {
						switch (inquiry.type) {
							case "CATEGORY":
								addCatNum();
								return (
									<ViewTitle
										title={catNum + "." + inquiry.title}
										description={inquiry.description}
										key={index}
									/>
								);
							case "SHORT":
								subNum++;
								return (
									<Input
										label={"[" + catNum + "-" + subNum + "] " + inquiry.title}
										name={`${catNum}input${subNum}`}
										required={inquiry.isRequired}
										className="f__column"
										key={index}
									/>
								);
							case "CHOICE":
								subNum++;
								return (
									<Radio
										label={"[" + catNum + "-" + subNum + "] " + inquiry.title}
										name="choice"
										options={inquiry?.option.map((q) => {
											return { label: q, value: q };
										})}
										required={inquiry.isRequired}
										className="c__tag-wrap f__column"
										key={index}
									/>
								);
							case "ALTERNATIVE":
								const optionsDataAlter = inquiry.option?.map((dt) => {
									return { label: dt, value: dt };
								});
								subNum++;
								return (
									<Radio
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											" 이지선다"
										}
										name="alternative"
										key={index}
										required={inquiry.isRequired}
										options={optionsDataAlter}
										className="c__tag-wrap f__column"
									/>
								);
							case "TAG":
								subNum++;
								return (
									<Tag
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"태그"
										}
										name="CompanyKeyword"
										key={index}
										className="c__tag-wrap f__column"
										required={inquiry.isRequired}
									/>
								);
							case "FILE":
								subNum++;
								return (
									<Group
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"첨부파일"
										}
										key={index}
										className="file-upload f__column"
										required={inquiry.isRequired}
									>
										<FileUploader name="file" />
										<ul className="note-list">
											{inquiry.description &&
												inquiry.description.split("\n").map((text) => {
													return (
														<li>
															<span>
																{text}
																<br />
															</span>
														</li>
													);
												})}
											<li className="default-note">
												최대 업로드 파일 크기: 100MB
											</li>
										</ul>
									</Group>
								);
							case "LINK":
								subNum++;
								return (
									<Input
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"링크 연결"
										}
										type="url"
										placeholder="https://www.example.com"
										name="url"
										required={inquiry.isRequired}
										className="f__column"
										key={index}
									/>
								);
							case "DATE":
								subNum++;
								return (
									<DatePicker
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"날짜"
										}
										name="date"
										key={index}
										className="c__tag-wrap f__column"
										required={inquiry.isRequired}
									/>
								);
							case "AGREE":
								subNum++;
								return (
									<Group
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"동의"
										}
										className="c__agree"
										key={index}
									>
										<Textarea
											name="agree"
											placeholder={inquiry.description}
											readonly={true}
										/>
										<label className={`checkbox-custom`}>
											<input type="checkbox" />
											<span className="checkmark" />
											<span className="checkbox-label">
												{inquiry.agreeDescription}
											</span>
										</label>
									</Group>
								);
							case "ADDRESS":
								subNum++;
								return (
									<Address
										label={
											"[" + catNum + "-" + subNum + "] " + inquiry.title ||
											"주소작성"
										}
										name={{
											postCode: "zipCode",
											address1: "address",
											address2: "addressDetail",
										}}
										required={inquiry.isRequired}
										key={index}
									/>
								);
							case "TEXT":
								return (
									<p
										className="certified-phrase"
										style={{
											color:
												inquiry.description === "red"
													? "#ff3c00"
													: inquiry.description === "blue"
													? "#00a4ff"
													: inquiry.description === "green"
													? "#71bb30"
													: "#ffd800",
										}}
										key={index}
									>
										{inquiry.title}
									</p>
								);
							case "LONG":
								subNum++;
								return (
									// <Input
									// 	label={"[" + catNum + "-" + subNum + "] " + inquiry.title}
									// 	name={inquiry.order.toString() + "_" + inquiry.title}
									// 	required={inquiry.isRequired}
									// 	className="f__column"
									// />
									<Textarea
										label={"[" + catNum + "-" + subNum + "] " + inquiry.title}
										name={`${catNum}LONG${subNum}`}
										required={inquiry.isRequired}
										className="f__column"
										key={index}
										maxLength={1000}
										showCount={true}
									/>
								);
							case "SELECT":
								subNum++;
								if (inquiry.title === "국가" && inquiry.disabled)
									return (
										<>
											<Select
												label={
													"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title
												}
												name="company.country"
												options={[
													{
														label: "한국",
														value: "korea",
													},
													{
														label: "일본",
														value: "japan",
													},
													{
														label: "미국",
														value: "usa",
													},
													{
														label: "중국",
														value: "china",
													},
													{
														label: "베트남",
														value: "vietnam",
													},
													{
														label: "기타",
														value: "etc",
													},
												]}
												className="f__column"
												required
												key={index}
											/>
											{country === "etc" ? (
												<Input
													name="etcCountry"
													required={inquiry.isRequired}
													className="f__column etc-country"
													card={inquiry}
													placeholder="국가를 입력해주세요."
												/>
											) : (
												<></>
											)}
										</>
									);
								else if (inquiry.title === "투자단계")
									return (
										<Select
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											name="company.investLevel"
											options={INVEST_LEVEL}
											required
											className="f__column"
											key={index}
										/>
									);
								else
									return (
										<Select
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											name={inquiry.title}
											options={inquiry?.option.map((q) => {
												return { label: q, value: q };
											})}
											required={inquiry.isRequired}
											className="c__tag-wrap f__column"
											card={inquiry}
										/>
									);
							case "MULTISELECT":
								subNum++;
								if (inquiry.title === "산업분야" && inquiry.disabled)
									return (
										<Tag
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											name={"industrytype"}
											key={index}
											className="c__tag-wrap f__column"
											required
										/>
									);
								else {
									return (
										<MultiCheckboxSelect
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											valueKey={"value"}
											name={`multiselect.${inquiry.title}`}
											options={inquiry?.option.map((q) => {
												return { label: q, value: q };
											})}
											placeholder={"선택해주세요."}
											required={inquiry.isRequired}
											selectedValues={[]}
											className="f__column"
										/>
									);
								}
							default:
								return <></>;
						}
					})}

				{/* <h3 className="form-title">3. 제품/기술/시장 </h3>
								<p className="form-sub-title">
									제안하는 제품/서비스에 대한 문제점, 해결방안에 대한 내용을
									입력해주세요.
								</p>

								<Textarea
									label="[3-1] 문제점"
									name="problem"
									required
									className="f__column"
								/>

								<Textarea
									label="[3-2] 해결방안"
									name="solution"
									required
									className="f__column"
								/>

								<Textarea
									label="[3-3] 팀 구성 및 소개"
									name="introduction"
									required
									className="f__column"
								/>

								<Tag
									label="[3-4] 제품 키워드"
									name="CompanyKeyword"
									className="c__tag-wrap f__column"
								/>

								<h3 className="form-title">4. 제출자료 </h3>
								<p className="form-sub-title">
									IR 자료와 소개영상 URL 을 입력해주세요
								</p>

								<Group label="[4-1] IR정보" className="file-upload f__column">
									<FileUploader name="file" />
									<ul className="note-list">
										<li>업로드 파일 제한 사항 입력 문구가 들어갑니다.</li>
										<li className="default-note">
											최대 업로드 파일 크기: 100MB
										</li>
									</ul>
								</Group>

								<Input
									label="[4-2] 소개영상"
									type="url"
									placeholder="URL을 입력해주세요."
									name="url"
									required
									className="f__column"
								/> */}
			</Form>

			{/* <div className="apply-form-btn">
								<button type="button" className="btn__solid" color="primary">
									제출하기
								</button>
							</div> */}
		</div>
	);
};

export default ViewInquery;
